// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__VURcb","image":"styles_image__o-bo-","text":"styles_text__1HB4a"};